import React, { Fragment } from 'react'
import { NavLink, Redirect } from "react-router-dom"
import { Alert } from 'react-bootstrap'
import { Box } from '@mui/system'
import { Tab, Tabs, TextField } from '@mui/material'

import Constants, { appConfig } from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { getLog } from '../../helpers/helpers.js'
import IpcLogRenderer from '../../helpers/IpcLogRenderer.js'

import '../../resources/css/restore_wallet.css'
import { ButtonPrimaryOutlined } from '../../components/Buttons.js'

const Mnemonic = require('bsv-mnemonic')


function await_sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

// DONT MODIFY STATE DIRECTLY but use setState() cf https://reactjs.org/docs/state-and-lifecycle.html



const InputModeEnum = {
    word_by_word: "word_by_word",
    full_phrase: "full_phrase",
}

/**
 * will only display children if value==target
 * props:
 *      - value
 *      - target
 */
function TabPanel(props) {
    const { children, value, target, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== target}
            id="simple-tabpanel"
            aria-labelledby={"simple-tab"}
            {...other}
        >
            {value === target && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}


// TODO convert to functional component
class Restore_Wallet_From_Seed extends React.Component {

    static contextType = UserContext

    constructor(props) {
        super(props)

        this.state = {
            mnemonic: [],  // mnemonics starts with "delphe" & we store as array
            full_phrase_text: "",  // raw textarea content for full_phrase mode
            redirect: false,
            errormess: "",
            success_mess: "",
            walletloaded: false,
            input_mode: InputModeEnum.word_by_word,
        }

        this.handleClickContinue = this.handleClickContinue.bind(this)
        this.handleChangeInputMode = this.handleChangeInputMode.bind(this)
        this.handleChangeSeedWordByWord = this.handleChangeSeedWordByWord.bind(this)
        this.handleChangeSeedFullPhrase = this.handleChangeSeedFullPhrase.bind(this)
        this.onChangedSeed = this.onChangedSeed.bind(this)
    }


    async handleChangeInputMode(event, new_mode) {
        const log = getLog("handleChangeInputMode")
        log("new_mode=", new_mode)
        this.setState({ input_mode: new_mode })
    }


    async handleChangeSeedWordByWord(event, word_index) {
        const log = getLog("handleChangeSeedWordByWord")

        const new_word = event.target.value.replace(/\s+/g, '')
        const new_mnemonic = this.state.mnemonic
        new_mnemonic[word_index - 1] = new_word

        // keep full_phrase_text in sync so both tabs share the same state
        this.setState({ full_phrase_text: new_mnemonic.filter(w => w).join(" ") })
        this.onChangedSeed(new_mnemonic)
    }


    async handleChangeSeedFullPhrase(event) {
        const log = getLog("handleChangeSeedFullPhrase")
        log()
        const str_mnemonic = event.target.value
        // store raw text (do not trim) so the user can type spaces freely
        this.setState({ full_phrase_text: str_mnemonic })
        // split on whitespace for validation only (empty tokens filtered out)
        const new_mnemonic = str_mnemonic.split(/\s+/).filter(w => w.length > 0)
        this.onChangedSeed(new_mnemonic)
    }


    /**
     * 
     * @param {array} new_mnemonic 
     * @returns 
     */
    async onChangedSeed(new_mnemonic) {
        const log = getLog("onChangedSeed")

        // reset
        this.setState({ walletloaded: false, errormess: "", success_mess: "" })
        this.forceUpdate()

        this.setState({ mnemonic: new_mnemonic })

        const nb_non_empty_words = new_mnemonic.filter(e => e.length > 0).length
        log("nb_non_empty_words=", nb_non_empty_words)

        if (nb_non_empty_words < 13) {
            const nb_missing = 13 - nb_non_empty_words
            this.setState({
                errormess: "La phrase doit contenir 13 mots (" + nb_missing + " mots manquants)",
                success_mess: "",
            })
        }
        else {
            this.setState({
                errormess:
                    <Fragment>
                        chargement du portefeuille en cours... &nbsp;
                        <i className="reloadIcon fas fa-sync fa-spin" />
                    </Fragment>
            })
            this.forceUpdate()

            await await_sleep(1)  // make sure that the display is not blocked

            try {
                const str_mnemonic = new_mnemonic.join(" ")
                // Store in pending_wallet (staging area) instead of injecting
                // directly into the real wallet fields. The wallet will be
                // atomically committed at the end of the flow via
                // commit_wallet() in wallet_password.js.
                await this.context.set_pending_wallet({
                    mnemonic: str_mnemonic,
                    network: this.context.network,
                })
                this.setState({ walletloaded: true, errormess: "", success_mess: "portefeuille chargé avec succès." })
            } catch (err) {
                // this.setState({ errormess: "impossible de charger ce portefeuille: " + err })
                this.setState({ errormess: "Phrase clé incomplète ou invalide.", success_mess: "" })
            }
        }

        this.forceUpdate()
    }


    async handleClickContinue(event) {
        // normalize the full phrase text (trim ends + collapse multiple spaces to single space)
        const normalized = this.state.full_phrase_text.trim().replace(/\s+/g, ' ')
        const normalized_mnemonic = normalized.split(" ")
        this.setState({ full_phrase_text: normalized, mnemonic: normalized_mnemonic, redirect: true })
    }

    render() {

        if (this.state.redirect === true) {
            this.context.update_newpassword_previous("restore_from_seed")
            return (
                // we use 'push' to not reload the page
                // <Redirect to="/wallet_password" push />
                <Redirect to="/enter_wallet_name" push />
            )
        }

        var nextbuttonstyle = {}
        if (!this.state.walletloaded) {
            nextbuttonstyle = { pointerEvents: "none", backgroundColor: "grey" }
        }

        let jsx_allwords_inputs = null
        for (let i = 1; i <= 13; i++) {
            const curr_val = this.state.mnemonic[i - 1]
            // check if the word is valid or an error to display visual feedback for each word
            let isvalid = false, iserror = false
            if (curr_val && curr_val.length > 3) {
                if ("delphe".startsWith(curr_val)) isvalid = true
                else if (Mnemonic.Words.FRENCH.some(w => w.startsWith(curr_val))) isvalid = true
                else iserror = true
            }
            jsx_allwords_inputs = <Fragment>
                {jsx_allwords_inputs}
                <TextField
                    // color="success" focused  // show success
                    // error  // show error
                    color={isvalid ? "success" : ""}
                    error={iserror ? true : false}
                    focused={isvalid || iserror ? true : false}
                    onChange={(event) => { this.handleChangeSeedWordByWord(event, i) }}
                    id={"word_" + i}
                    label={"Mot " + i}
                    value={curr_val}
                    size="small"
                    style={{ backgroundColor: "black", margin: "0.25em" }}
                /> &nbsp;
            </Fragment>
        }

        let first_word = appConfig.name.toLowerCase()
        if (first_word == "tokkenr") first_word = "tokkenR"

        return (
            <div className="mode-selection-style">
                <h2>
                    <br />
                    {Constants.RESTORE_WALLET_PAGE}
                </h2>
                <br />

                <div className="wallet-seed">

                    <label htmlFor="wallet_seed">
                        {Constants.MNEMONIC_SEED} Normalement le premier mot est "{first_word}".
                    </label><br /><br />

                    <div>

                        <Tabs
                            value={this.state.input_mode}
                            onChange={this.handleChangeInputMode}
                            textColor="primary"
                            indicatorColor="primary"
                        >
                            <Tab value="word_by_word" label="Mot par mot" id="tab-1" />
                            <Tab value="full_phrase" label="Phrase entière" id="tab-2" />
                        </Tabs>

                        <TabPanel value={InputModeEnum.word_by_word} target={this.state.input_mode}>
                            {jsx_allwords_inputs}
                        </TabPanel>

                        <TabPanel value={InputModeEnum.full_phrase} target={this.state.input_mode}>
                            <textarea type="text" value={this.state.full_phrase_text}
                                onChange={this.handleChangeSeedFullPhrase}
                                placeholder={Constants.MNEMONIC_SEED_PLACEHOLDER}
                                name="wallet_seed" id="seed"
                                style={{ margin: "0" }}
                            />
                        </TabPanel>

                        {this.state.errormess ?
                            <Alert variant="warning" style={{ fontWeight: "bold", fontSize: "16px" }}>
                                <i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
                                {this.state.errormess}
                            </Alert>
                            : null}

                        {this.state.success_mess ?
                            <Alert variant="success" style={{ fontWeight: "bold", fontSize: "16px" }}>
                                <i className="fa fa-check" style={{ fontSize: "20px" }} /> &nbsp;
                                {this.state.success_mess}
                            </Alert>
                            : null}

                    </div>

                </div>

                {/* Buttons */}

                <div className="bottom-buttons">

                    <div className="return-button">
                        <NavLink className="return-logo" to="/select_wallet">
                            <ButtonPrimaryOutlined>
                                Back
                            </ButtonPrimaryOutlined>
                        </NavLink>
                    </div>

                    <div className="next-button" >
                        <button onClick={this.handleClickContinue} style={nextbuttonstyle}
                            className="button-main-style">
                            Next
                        </button>
                    </div>

                </div>

                {/* make it easier to scroll if needed */}
                <div style={{ height: "40vh" }}>&nbsp;</div>
            </div>
        )
    }
}

export default Restore_Wallet_From_Seed
